import DataTable from "../../1. Core/Controls/DataTable/DataTable";
import Control from "../../1. Core/Control";
import NP from "../../1. Core/NP";
import { Collection } from "../types";
import { ServerAPI } from "../../1. Core/ServerAPI";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import IconToggleButton from "../../1. Core/Controls/IconToggleButton/IconToggleButton";

import EditCollectionDialog from "./EditCollectionDialog";
import Menu from "../../1. Core/Controls/Menu/Menu";
import ListItem from "../../1. Core/Controls/ListBox/ListItem";
import PackTable from "./PackTable";
import {EventTournament, PageMode} from "../../10. Battle/types";

export default class CollectionList extends Control {
    private _dataTable: DataTable;
    private _topAppBar: TopAppBar;
    private _drillDownPanel: PackTable
    private _rootNode: HTMLElement;

    constructor(settings: object) {
        super(settings);
        this._render();
    }

    getTopAppBar(){
        return this._topAppBar;
    }

    _render() {
        this.np_render();
        this.addClass('');

        this._rootNode = NP.createNode(this._root);

        this._topAppBar = new TopAppBar({
            Caption: "Collections",
            Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
            ParentNode: this._rootNode,
            ShowSearchButton: false,
            RightItems: NP.getCurrentUser().isBDAdmin() ? [
                new IconToggleButton({
                    FontImage: NP.FontImages.add,
                    EvClick: () => new EditCollectionDialog({
                        EvOkButtonClick: () => this.refresh()
                    }).show()
                }),
            ] : [],
        });

        this._dataTable = new DataTable({
            ParentNode: this._rootNode,
            Columns: [
                { Content: "Id", PropertyContent: "id", Width: "10%" },
                { Content: "Start At", PropertyContent: "start_at", Width: "20%" },
                { Content: "End At", PropertyContent: "end_at", Width: "20%" },
                { Content: "Gift", PropertyContent: "completion_gift", Width: "20%" },
                { Content: "Background", PropertyContent: "background_asset", Width: "20%" },
                { Content: "Name ES", PropertyContent: "name_es", Width: "20%" },
                { Content: "Name PT", PropertyContent: "name_pt", Width: "20%" },
            ],
            ShowSettingsButton: true,
            EvItemClick: (s: object, e: { Item: Collection }) =>
            {
                this.showPackList(e.Item);
            },
            EvItemContextMenu: async (s: any, e: { Event: any, Item: Collection }) => {
                let menu = new Menu({
                    Items: [
                        { FontImage: NP.FontImages.edit, RK: "Edit", Value: "Edit" },
                        { FontImage: NP.FontImages.delete, RK: "Remove", Value: "Remove" },
                    ],
                    EvItemSelected: async (s: Menu, event: { Item: ListItem }) => {
                        switch (event.Item.getValue()) {
                            case "Edit":
                                new EditCollectionDialog({
                                    Collection: e.Item,
                                    EvOkButtonClick: () => this.refresh()
                                }).show();
                                break;
                            case "Remove":
                                NP.showConfirm({
                                    Content: "Удалить коллекцию?",
                                    EvOkButtonClick: async () => {
                                        await ServerAPI.callUiApi("/fantasy/card-collections/collections/" + e.Item.id, null, "DELETE");
                                        this.refresh();
                                    }
                                });
                                break;
                        }
                    }
                });
                menu.showContextMenu(e.Event);
            }
        });

        this.refresh();
    }

     async refresh() {
        let collections = await ServerAPI.get<Collection[]>(`/fantasy/card-collections/collections`);
        this._dataTable.setRows(collections);
    }

    showPackList(col: Collection)
    {
        NP.updateBrowserUrlString(true, PageMode.collection, col.id);

        NP.hideNode(this._rootNode);


        this._drillDownPanel = new PackTable({
            ParentNode: this._root,
            Width: this._Width,
            Event: event,
            Height: this._Height,
            CollectionId: col.id,
            EvBackClick: () =>
            {
                NP.updateBrowserUrlString(true, PageMode.collection);
                NP.showNode(this._rootNode);
                this._drillDownPanel.destroy();
                this._drillDownPanel = null;
                this.refresh();
            }
        })
    }
}
